export const frontEndSkills = ["HTML", "CSS", "JavaScript", "React", "Redux"];

export const backEndSkills = [
  "Node.js",
  "Express.js",
  "REST API",
  "SQL",
  "PostgreSQL",
];

export const miscSkills = [
  "Git (Version Control)",
  "GitHub",
  "Test Driven Development",
  "Continuous Integration",
  "Vercel",
  "Heroku",
];
